import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { VeiculoRastreamento } from "model/transportes/rastreamento/VeiculoRastreamento";
import { useEffect, useState } from "react";
import RastreamentoService from "service/transportes/RastreamentoService";
import { converterDataHora } from "utils/convert";
import { RotateIcon } from "./rotateImage";

const rastreamentoService = new RastreamentoService();
export function RastreamentoPage() {

    const keyMaps = 'AIzaSyDQbLYImEY_K1U92ocx6-e46qC2AjskIfo';
    const [center, setCenter] = useState({ lat: -28.6782, lng: -49.370176 });

    const [veiculosRastreados, setVeiculosRastreados] = useState<VeiculoRastreamento[]>([]);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: keyMaps,
    })

    useEffect(() => {
        rastreamentoService.getVeiculoRastreamento().then((veiculosRastreamento) => {
            veiculosRastreamento.forEach((veiculo) => {
                veiculo.image = RotateIcon
                    .makeIcon(
                        '/imagens/caminhao-maps.png')
                    .setRotation({ deg: veiculo.inclinacao || 0 })
                    .getUrl();
            });
            setVeiculosRastreados(veiculosRastreamento);
        }).catch((error) => {
            console.error(error);
        });
    }, [])

    const [map, setMap] = useState<google.maps.Map | null>(null)

    const listaFlutuante = <div style={{
        display: "flex", flexDirection: "column", zIndex: 100, position: "fixed",
        padding: 10, backgroundColor: "white", borderRadius: 5
    }}>
        <h3 style={{ textAlign: "center" }}>Veículos</h3>
        {veiculosRastreados.map((veiculo, index) => {
            return <div key={index} onClick={() => {
                setCenter({ lat: veiculo.latitude, lng: veiculo.longitude });
            }} style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", borderBottom: "1px solid #ccc", padding: 5, cursor: "pointer" }}>
                <div>{veiculo.veiculo?.modelo} - {veiculo.veiculo?.placa}</div>
                <div>{veiculo.motorista?.nome} - {veiculo.motorista?.numeroDocumento}</div>
                <div><b>Última atualização:</b> {converterDataHora(veiculo.ultimaAtualizacao)}</div>
            </div>
        })}
    </div>

    return (
        <div>
            {listaFlutuante}
            <div style={{ width: "100%", top: 0, left: 0, position: "absolute", zIndex: 1 }}>

                {isLoaded ? <GoogleMap
                    onLoad={(map) => {
                        const bounds = new window.google.maps.LatLngBounds(center)
                        map.fitBounds(bounds)
                        var listener = google.maps.event.addListener(map, "idle", function () {
                            if ((map.getZoom() || 0) > 15) map.setZoom(15);
                            google.maps.event.removeListener(listener);
                        })
                        setMap(map);
                    }}
                    zoom={15}
                    center={center}
                    onUnmount={() => { }}
                    mapContainerStyle={{
                        height: "100vh",
                        width: "100%"
                    }}
                >
                    {veiculosRastreados.map((veiculo, index) => {

                        return <Marker position={{ lat: veiculo.latitude, lng: veiculo.longitude }} icon={{
                            url: veiculo.image,
                                scaledSize: new google.maps.Size(52, 60),
                        }} />
                    })}
                </GoogleMap> : null}
            </div>
        </div>

    )
}